import CropwiseResource, { CropwiseField } from '../CropwiseResource';
import { getFieldsByPropertyId } from '../utils/getFieldsByPropertyId';
import { getPropertiesByOrgId } from '../utils/getPropertiesByOrgId';

export const getCropwiseFields = async ({
  org_id,
  access_token,
}: {
  org_id: string;
  access_token: string;
  controller?: AbortController;
}) => {
  const properties_response = await getPropertiesByOrgId(org_id, access_token);
  if (properties_response.error_type) {
    return properties_response;
  }
  const properties = properties_response?.map((property: any) => new CropwiseResource(property));
  const field_promises: Promise<any>[] = [];
  properties.forEach((property: any) => {
    field_promises.push(getFieldsByPropertyId(property.id, access_token));
  });
  const field_responses = await Promise.all(field_promises);
  let all_fields: any[] = [];
  let most_recent_error: any = null;
  field_responses.forEach((result: any, index: number) => {
    if (!result || result.error_type) {
      most_recent_error = result ?? 'An error occurred';
    } else {
      all_fields = [
        ...all_fields,
        ...result.map((field: any) => new CropwiseField(field, properties[index].name)),
      ];
    }
  });

  return most_recent_error ?? all_fields;
};
